module.exports = __webpack_public_path__ + "static/Heebo-Light-30cb398dc788a7f4349f6d0406b41c63.woff";